import { combineReducers } from "redux";
import { marker } from "./marker";
import connection from "./connection";
import service from "./service";
import promotion from "./promotion";
import form from './form';
import timeslots from './timslots';
import status from './status';
import error from './error';
import sales_rep from './sales-rep';
import recentBuildings from './recentBuildings';
import promotion_info from './promotionInfo';
import app from './app'
import geo from './geo';
import buildingsByServiceAvailable from './buildings-by-service-available';
import taxes from './taxes';
import beanid from './beanid';

const rootReducer = combineReducers({
  app,
  marker,
  connection,
  service,
  promotion,
  form,
  timeslots,
  status,
  error,
  sales_rep,
  recentBuildings,
  promotion_info,
  geo,
  buildingsByServiceAvailable,
  taxes,
  beanid
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/index.js